/* eslint-disable implicit-arrow-linebreak */
export const monetaryUSDFormat = (value: number): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
